<div class="operations-details-table">
  <div class="operations-details-table-title-container">
    <fw-icon size="small" [color]="iconColor">{{ icon }}</fw-icon>
    <span class="operations-details-table-title">
      {{ title }}
    </span>
  </div>
  <div class="operations-details-table-body">
    @for (row of tableConfig; track row.title) {
      <div
        class="operations-details-table-body-row"
        [ngClass]="{ small: isSmall, danger: row.isDanger, warning: row.isWarning }"
      >
        <span>{{ row.title }}</span>
        <span>{{ isShowCount(row.count) ? row.count : 'N/A' }}</span>
      </div>
    }

    @if (isWithTotal) {
      <div class="operations-details-table-body-row total" [class.small]="isSmall">
        <span>TOTAL</span>
        <span>{{ total }}</span>
      </div>
    }
  </div>
</div>
